module.exports = __webpack_public_path__ + "static/media/logo.7e708bf3.png";